import {
  ListUsersQueryParams,
  listUsersQuerySortByDefault,
  listUsersQuerySortDirDefault,
} from "@project/sdk/admin/zod";
import {z} from "zod";

import {zUrlArray, zUrlIsoDate, zUrlNumber} from "../../../../shared/utils/zod-url";

export const usersSearchSchema = z.object({
  page: ListUsersQueryParams.shape.page.catch(1),
  perPage: ListUsersQueryParams.shape.perPage.catch(20),
  q: ListUsersQueryParams.shape.q.catch(undefined),
  sortBy: ListUsersQueryParams.shape.sortBy.catch(listUsersQuerySortByDefault),
  sortDir: ListUsersQueryParams.shape.sortDir.catch(listUsersQuerySortDirDefault),
  roles: zUrlArray(ListUsersQueryParams.shape.roles),
  dateRangeStart: zUrlIsoDate(ListUsersQueryParams.shape.dateRangeStart),
  dateRangeEnd: zUrlIsoDate(ListUsersQueryParams.shape.dateRangeEnd),
  departments: zUrlArray(ListUsersQueryParams.shape.departments),
  seniorityRangeMin: zUrlNumber(ListUsersQueryParams.shape.seniorityRangeMin),
  seniorityRangeMax: zUrlNumber(ListUsersQueryParams.shape.seniorityRangeMax),
});

export type UsersSearch = z.infer<typeof usersSearchSchema>;
